import agent, { prepareHeaders } from 'api/agent';
import { ClosingModel, PagedList, RefundRow } from 'api/models';
import axios from 'axios';
import { ClosingReportType, ClosingVariants } from 'components/restaurantInformation/closings';

export const Payments = {
    GetClosingsReports: (
        page: number = 0,
        limit: number = 20,
        variant: ClosingVariants = ClosingVariants.Periodic,
        type?: ClosingReportType,
        asc: boolean = false,
        orderBy: string = 'dateFrom'
    ) =>
        agent.requests.get('/Payment/closings', {
            params: { page, limit, variant, asc, orderBy, ...(type && { type }) },
        }),
    GetLastClosingReport: (restaurantId: string = '') =>
        agent.requests.get('/Payment/closings/last', { params: { restaurantId } }),
    GetPayments: (page: number = 0, limit: number = 20) =>
        agent.requests.get('/Payment', { params: { page, limit } }),
    CreateNewClosingReport: (model: ClosingModel) =>
        agent.requests.post('/Payment/closings', model),
    GenerateClosingReportPDF: (id: string, name?: string) =>
        axios
            .get(`/Payment/closings/${id}`, { ...prepareHeaders(), responseType: 'blob' })
            .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', name || 'daily-closing.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }),
    GenerateClosingReportPDFForPrint: (id: string) =>
        axios
            .get(`/Payment/closings/${id}`, { ...prepareHeaders(), responseType: 'blob' })
            .then(({ data }) => {
                const blobUrl = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/pdf' })
                );
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = blobUrl;
                iframe.onload = function () {
                    setTimeout(() => {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.focus();
                        }
                        if (iframe.contentWindow) {
                            iframe.contentWindow.print();
                        }
                        URL.revokeObjectURL(blobUrl);
                    }, 100);
                };

                document.body.appendChild(iframe);
            }),
    GeneratePaymentReceiptPDF: (id: string) =>
        axios
            .get(`/Payment/${id}/receipt`, { ...prepareHeaders(), responseType: 'blob' })
            .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/pdf' })
                );
                window.open(downloadUrl);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'receipt.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }),
    GeneratePaymentReceiptPDFForPrint: (id: string) =>
        axios
            .get(`/Payment/${id}/receipt`, { ...prepareHeaders(), responseType: 'blob' })
            .then(({ data }) => {
                const blobUrl = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/pdf' })
                );
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = blobUrl;

                iframe.onload = function () {
                    setTimeout(() => {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.focus();
                        }
                        if (iframe.contentWindow) {
                            iframe.contentWindow.print();
                        }
                        URL.revokeObjectURL(blobUrl);
                    }, 100);
                };

                document.body.appendChild(iframe);
            }),
    GetRefunds: (page: number = 0, limit: number = 20): Promise<PagedList<RefundRow>> =>
        agent.requests.get('/Payment/refunds', { params: { page, limit } }),
    GenerateRefundReceiptPDF: (refundReceiptId: string) =>
        axios
            .get(`/Payment/${refundReceiptId}/refund-receipt`, {
                ...prepareHeaders(),
                responseType: 'blob',
            })
            .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/pdf' })
                );
                window.open(downloadUrl);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'refund-receipt.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }),
    GenerateRefundReceiptPDFForPrint: (refundReceiptId: string) =>
        axios
            .get(`/Payment/${refundReceiptId}/refund-receipt`, {
                ...prepareHeaders(),
                responseType: 'blob',
            })
            .then(({ data }) => {
                const blobUrl = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/pdf' })
                );
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = blobUrl;

                iframe.onload = function () {
                    setTimeout(() => {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.focus();
                        }
                        if (iframe.contentWindow) {
                            iframe.contentWindow.print();
                        }
                        URL.revokeObjectURL(blobUrl);
                    }, 100);
                };

                document.body.appendChild(iframe);
            }),
};
